import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

const apiurl = process.env.REACT_APP_API_URL

interface PendingCourse {
    id: number
    code: string
    name: string
    organizationPath: string
}

const SurveyFeedbackDashboardBox: React.FC = () => {
    const [courses, setCourses] = useState<PendingCourse[]>([])

    useEffect(() => {
        axios
            .get(`${apiurl}/Custom/GetPendingSurveyFeedbacks`)
            .then((res) => {
                setCourses(res.data)
            })
            .catch((err) => {
                console.error('Feedback listesi alınamadı:', err)
            })
    }, [])

    if (courses.length === 0) return null

    return (
        <div className="container my-4">
            <h3 className="mb-3 text-center">📋 Geri Bildirim Bekleyen Dersler</h3>
            <div className="row">
                {courses.map((course) => (
                    <div className="col-12 col-md-6 col-lg-4 mb-4" key={course.id}>
                        <Link
                            to="/surveyresult"
                            state={course.id}
                            className="btn btn-outline-primary text-start shadow-sm w-100 h-100 p-4"
                            style={{ fontSize: '1rem' }}
                        >
                            <div className="fw-bold mb-2">{course.name}</div>
                            <div className="text-muted small">{course.code}</div>
                            <div className="text-muted small">{course.organizationPath}</div>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default SurveyFeedbackDashboardBox
